import { getStore } from '../store/store';

export function isCreatingNewFolder(): boolean {
    return getStore().createFolderViewState.isCreating;
}

export function getNewFolderName(): string {
    const store = getStore();
    if (store.createFolderViewState.isCreating) {
        return store.createFolderViewState.folderName;
    }

    return null;
}

export function isUserEnteringNewFolderName(): boolean {
    const { createFolderViewState } = getStore();

    return createFolderViewState.isCreating === false
        ? createFolderViewState.isUserEnteringText
        : false;
}
